import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { onCancelDialog } from '../handler/ProjectUserManagementHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CancelDialogAddUser({ isOpen, argsAll}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const onCloseDialogReject = (event, reason) => {
        argsAll.setOpenCancelDialog(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{trI18n('USER09MSG001')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={() => onCancelDialog(argsAll)}
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
